import React, { FC } from "react";
import { Box, Text, Icon, Rotate } from "designsystem";
import { FaqItem } from "utils/support/faq";
import Link from "designsystem/components/link";
import * as styles from "./styles/faq.module.scss";
import pushToDataLayer from "utils/gtm";

type FaqItemSummaryProps = Pick<FaqItem, "question" | "summary"> & {
  url: string;
  page: number;
  activeTopic?: string;
  resultsLength?: number;
  rank?: number;
};
const FaqItemSummary: FC<FaqItemSummaryProps> = ({
  question,
  summary,
  url,
  page,
  activeTopic,
  resultsLength,
  rank
}) => {
  return (
    <Box
      border="top"
      paddingTop="m"
      paddingBottom="m"
      onClick={() => {
        pushToDataLayer("custom_search", "click", {
          search: {
            topic: activeTopic === undefined ? "All" : activeTopic,
            topic_type: "default",
            result: resultsLength,
            /* eslint-disable @typescript-eslint/no-non-null-assertion */
            rank: (page - 1) * 10 + rank! + 1,
            target: url
          }
        });
      }}
      direction="column"
    >
      <Link href={url} className={styles.link}>
        <Box alignItems="baseline" justifyContent="space-between">
          <Text as="h3" size="l">
            {question}
          </Text>
          <Rotate startRotation="three-quarters">
            <Icon type="chevron" marginLeft="m" />
          </Rotate>
        </Box>
        {summary && <p>{summary}</p>}
      </Link>
    </Box>
  );
};

export default FaqItemSummary;
